 <template>
    <div>
        <div class="container">
          <h1 class="page-header">
               <span>Mortgage
                 <span class="orange-link">Advice</span></span>
            <hr/>
          </h1>
            <div class="mortgage-info">
                <h2>First Time Buyer </h2>
                <hr />
                <p>Buying your first home is an exciting yet daunting prospect. So many things to consider, so many questions to ask – we will support you and hold your hand throughout the process from start to finish. Offering whole of market mortgage advice, recommending and liaising with solicitors, assisting with all relevant documentation on your behalf and much more – no stone is unturned when dealing with our friendly team. </p>
            </div>
            <div class="mortgage-info">
                <h2>Remortgage</h2>
                <hr />
                <p>Remortgaging can be used for many reasons including home improvements to your property,
                  consolidating debt, borrowing additional funds to purchase another property or simply seeking a lower
                  interest rate.<br></p>
                <p>  However, most people simply switch mortgage products and lenders to get the best deal and rates. For
                example; the introductory fixed deal has now finished, your mortgage will move to the lenders standard
                  variable rate (SVR).  This generally will have a higher interest rate but will not have any exit
                  fees. Moving to a new deal with your current lender may not be the right option, this is
                  where we can help search the whole of market.<br></p>
            </div>
            <div class="mortgage-info">
                <h2>Home Mover</h2>
                <hr />
                <p>Taking the leap to jump ship and move home is exciting yet intimidating.<br></p>
                <p>Moving your current mortgage to fund this purchase can be quite complicated however not impossible.
                Most lenders will allow you to move your mortgage to the new property, but you should seek advice to
                  ensure you are getting the right deal. This is where we can help. We’re here to put your mind at ease
                  and guide you to the most suitable deal for your new home.</p>
            </div>
            <div class="mortgage-info">
                <h2>Buy to Let</h2>
                <hr />
                <p>Having a second property to let to tenants could reap considerable financial rewards.  More and more
                  people have turned to this form of investment to grow their wealth; however, it is not without risk
                  .<br></p>
                <p>
                  Becoming a private landlord should not be seen as an easy way of making money. It can be riskier and
                  more complicated than it first appears.   It can also be very time consuming, more than most forms of
                  investment, and there is no guarantee that house prices will rise.<br></p>
                <p>Recent government changes have made this area of investment needing more advice than ever before.  We
                        have access to the to the whole of market and can help find the right deal for you and your
                  investment whether you chose to have 1 property or a whole portfolio. <br></p>
                <p>
                  <br>
                  * This information is intended to provide a general understanding of the topic. The contents should not
                  be treated as advice. For personalised advice, please submit an enquiry.<br>
                  <br>
                  Think carefully before securing other debts against your home. Your home may be repossessed if you do not keep up repayments on your mortgage.
                  <br>
                  <br>
                  Some Buy to Lets are not regulated by the Financial Conduct Authority. </p>
            </div>
          <div id="contact-us-advice" class="row contact-us">
            <div class="col-lg-7">
              <p><strong>
                For more information, please get in touch and we will be happy to assist you.
              </strong>
              </p>
              <div v-if="errors.length" class="errors">
                <p>Please correct the following error(s):</p>
                <ul>
                  <li v-for="error in errors" :key="error">
                    {{ error }}
                  </li>
                </ul>
              </div>
              <div v-if="success" class="success">
                <b>Your message has been sent successfully</b>
              </div>
              <netlify-form
                name="contact-form"
                netlify-honeypot="bot-field"
              >
                <div class="row">
                  <div class="form-group col-md-6">
                    <label for="first-name" class="required"
                    >First name</label
                    >
                    <input
                      v-model="firstName"
                      name="firstName"
                      id="first-name"
                      class="form-control"
                      type="text"
                      placeholder="Your first name"
                    />
                  </div>
                  <div class="form-group col-md-6">
                    <label for="last-name" class="required"
                    >Last name</label
                    >
                    <input
                      v-model="lastName"
                      name="lastName"
                      id="last-name"
                      class="form-control"
                      type="text"
                      placeholder="Your last name"
                    />
                  </div>
                  <div class="form-group col-md-6">
                    <label for="email-name" class="required"
                    >Email</label
                    >
                    <input
                      v-model="email"
                      name="email"
                      id="email-name"
                      class="form-control"
                      type="email"
                      placeholder="Your email"
                    />
                  </div>
                  <div class="form-group col-md-6">
                    <label for="phone" class="required"
                    >Phone</label
                    >
                    <input
                      v-model="phone"
                      name="phone"
                      id="phone"
                      class="form-control"
                      type="text"
                      placeholder="Your phone"
                    />
                  </div>
                  <div class="form-group col-md-12">
                    <label for="message" class="required"
                    >Your message</label
                    >
                    <textarea
                      v-model="message"
                      name="message"
                      id="message"
                      class="form-control"
                      placeholder="Your message"
                      rows="5"
                    ></textarea>
                  </div>
                  <div class="col">
                    <label class="required">GDPR Agreement</label>

                    <div id="checkbox-container" class="checkbox-container">
                      <input
                        v-model="gdpr"
                        type="checkbox"
                        name="checkbox"
                        id="email-chkbox"
                        required
                      />
                      <div class="icon-check-container">
                        <svg class="icon icon-check-square"><use
                          xlink:href="#icon-check-square"></use></svg>
                      </div>
                      <label
                        id="chckbox-label"
                        for="email-chkbox"

                      >
                        I consent to having this website store
                        my submitted information so they can
                        respond to my enquiry.
                      </label>
                    </div>
                    <div><a target="_blank" href="https://www.quilter.com/important-information/privacy-notices/appointed-representative-privacy-notice/" class="orange-link">Read our privacy notice</a></div>
                    <div class="form-group form-button col-md-12">
                      <button
                        @click="onSubmit"
                        type="submit"
                        class="form-button btn mt-4"
                      >
                        Submit
                      </button>
                    </div>
                  </div>
                </div>
              </netlify-form>
            </div>
            <p></p>
          </div>

          </div>
        <div class="cta">
          <div class="container">
            <div class="row d-flex align-items-center justify-content-between">
              <h2 class="mb-0 d-flex justify-content-center">
                <strong>Get In Touch</strong>
              </h2>
              <p>Whether you are wanting a face-to-face visit, zoom meeting or a quick chat over the phone to discuss
                your options, we can schedule a time most suited to you.</p>
              <div class="d-flex justify-content-end align-items-center">
                <router-link to="/contact-us/" class="btn btn-orange btn-block">Contact Us</router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
</template>

<script>
import NetlifyForm from "@/components/forms/NetlifyForm";
export default {
  name: 'MortgageAdvice',
  components: {
    NetlifyForm,
  },
  data() {
    return {
      firstName: null,
      lastName: null,
      phone: null,
      email: null,
      message: null,
      gdpr: false,
      errors: [],
      success: false,
    };
  },
  methods: {
    onSubmit(e) {
      this.errors = [];
      this.success = false;

      if (!this.firstName) {
        this.errors.push("First Name required");
      }
      if (!this.lastName) {
        this.errors.push("Last Name required");
      }
      if (!this.email) {
        this.errors.push("Email required");
      } else if (!this.validEmail(this.email)) {
        this.errors.push("Valid email required");
      }
      if (!this.phone || !this.validPhoneNumber(this.phone)) {
        this.errors.push("Valid phone number required");
      }
      if (!this.message) {
        this.errors.push("Message required");
      }
      if (!this.gdpr) {
        this.errors.push(
          "We are unable to submit your enquiry, without consent to hold your data"
        );
      }
      if (this.errors.length) {
        e.preventDefault();
      }
    },
    validEmail: function (email) {
      let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    validPhoneNumber: function (phoneNumber) {
      phoneNumber = phoneNumber.replace(/[()]+/g, "");
      let number = /^(((\+44\s?\d{4}|\(?0\d{4}\)?)\s?\d{3}\s?\d{3})|((\+44\s?\d{3}|\(?0\d{3}\)?)\s?\d{3}\s?\d{4})|((\+44\s?\d{2}|\(?0\d{2}\)?)\s?\d{4}\s?\d{4}))(\s?#(\d{4}|\d{3}))?$/;
      return number.test(phoneNumber);
    },
  },
};

</script>

 <style scoped>
 .contact-image {
   background-color: #fff;
   border: 5px solid #fff;
 }
 .brdr {
   border: 15px solid #f7941d;
 }
 .errors,
 .success {
   padding: 15px;
   border-radius: 5px;
   margin-bottom: 30px;
 }

 .success {
   color: #1c723d;
   background-color: #d7f8e5;
   border-color: #c6f5d6;
 }

 .errors {
   color: #721c24;
   background-color: #f8d7da;
   border-color: #f5c6cb;
 }
 </style>



// WEBPACK FOOTER //
// src/components/pages/MortgageAdvice.vue